<template>
  <BModal :value="value" :title="title" @input="$emit('input', false)">
    <div slot="body" class="content">
      <slot></slot>
      <p v-if="!mode" class="has-text-weight-bold">Are you sure?</p>
    </div>
    <div slot="footer">
      <button
        class="button"
        :class="[
          (confirmBtn && confirmBtn.css) || {
            'is-danger': !confirmBtn || !confirmBtn.css
          }
        ]"
        @click="Confirm()"
      >{{ (confirmBtn && confirmBtn.text) || "Yes" }}</button>
      <button
        class="button"
        :class="[cancelBtn && cancelBtn.css]"
        @click="$emit('input', false)"
      >{{ (cancelBtn && cancelBtn.Text) || "Cancel" }}</button>
    </div>
  </BModal>
</template>

<script>
import BModal from "@/components/singles/BModal/component.vue";

export default {
  components: { BModal },
  props: ["value", "title", "mode", "confirmBtn", "cancelBtn"],
  data() {
    return {
      show: false
    };
  },
  methods: {
    async Confirm() {
      this.$emit("input", false);
      this.$emit("confirmed", true);
    }
  }
};
</script>
